var exports = {};

function elasticIn(t) {
  return Math.sin(13 * t * Math.PI / 2) * Math.pow(2, 10 * (t - 1));
}

exports = elasticIn;
export default exports;